interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeStyles = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
};

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    <div className={`${sizeStyles[size]} ${className}`}>
      <div className={`${sizeStyles[size]} border-3 border-gray-200 border-t-blue-600 rounded-full animate-spin`} />
    </div>
  );
}

interface LoadingContainerProps {
  text?: string;
}

export function LoadingContainer({ text = 'Cargando...' }: LoadingContainerProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-100 py-12">
      <Spinner size="lg" />
      <p className="mt-4 text-gray-500 text-sm">{text}</p>
    </div>
  );
}
